import angular from 'angular';

export default function DemoSettingsDialogController(
  $scope,
  $timeout,

  alerts,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleExpandSettingsSection = _handleExpandSettingsSection;
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleEditSettingsFormSubmit = _handleEditSettingsFormSubmit;

  _activate();

  function _activate() {
    vm.newSettings = angular.copy(vm.settings);
  }

  function _handleExpandSettingsSection($event, section) {
    // Load the data if you don't already have it
    if (!vm[`${section}IsLoaded`]) {
      // Fake data loading for illustrative purposes
      $timeout(
        () => {
          vm[`${section}IsLoaded`] = true;
        },
        500
      );
    }
    vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.demo.settingsDialog);
  }

  function _handleEditSettingsFormSubmit() {
    if ($scope.editDemoSettingsForm.$valid) {
      loaderService.showViewLoader = true;
      // Save Settings, this is mocked up for illustrative purposes
      $timeout(
        () => {
          loaderService.showViewLoader = false;
          alerts.success('The Demo settings have been successfully saved.');
          _closeDialog();
        },
        1000
      );
    }
  }
}

DemoSettingsDialogController.$inject = [
  '$scope',
  '$timeout',

  'alerts',
  'loaderService',
  'ssDialogService',
];
